import { type Route } from "./+types/terms";

export const meta: Route.MetaFunction = () => {
  return [{ title: "Terms of Service | shonaslang" }];
};

export default function TermsPage() {
  return (
    <div className="container py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-muted-foreground mb-6">
            Effective date: January 2025
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">1. Who we are</h2>
            <p>
              shonaslang ("we", "our", "the Service") is an online dictionary
              that lets users submit, translate and vote on Zimbabwean slang
              words.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">2. Your account</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must be ≥ 18 years old.</li>
              <li>
                Register with a valid email; you're responsible for activity
                under your account.
              </li>
              <li>
                Handles must not impersonate, harass or infringe trademarks.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">
              3. User-generated content
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Anything you post-words, definitions, examples, comments - is
                "User Content".
              </li>
              <li>
                You grant us a non-exclusive, royalty-free, worldwide licence to
                store, display, modify (e.g. spelling fixes) and distribute that
                content in any medium, including future APIs.
              </li>
              <li>
                Don't post: hate speech, personal data, illegal content, spam,
                or copyrighted material you don't own.
              </li>
              <li>
                We may remove or edit content or suspend accounts at our sole
                discretion.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">
              4. Voting & moderation
            </h2>
            <p>
              Votes are recorded per definition. Our moderators can override
              votes, approve, reject or edit submissions to maintain quality.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">5. Acceptable use</h2>
            <p>
              No scraping at scale, no reverse engineering our code, no attempts
              to disrupt the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">
              6. Intellectual property
            </h2>
            <p>
              Site design, logo and compiled dictionary exports are ©
              shonaslang 2025. Logos and trademarks remain the property of their
              respective owners.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">7. Disclaimers</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                The Service is provided "as-is". We make no warranties about
                accuracy or availability.
              </li>
              <li>
                We're not liable for any loss (including data loss or lost
                profits) arising from your use of the Service.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">8. Termination</h2>
            <p>
              You can delete your account anytime; we may keep anonymised word
              data to preserve dictionary integrity.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">
              9. Changes to these Terms
            </h2>
            <p>
              We'll post updates here and, for major changes, email registered
              users.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">10. Governing law</h2>
            <p>
              These Terms are governed by the laws of Zimbabwe. Disputes will be
              resolved in Zimbabwean courts.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">11. Contact</h2>
            <p>Questions? legal@shonaslang.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
